<template>
  <div class="banner-template">
    <div v-if="adId && ((banners||[]).length < (adId === 2 ? 1 : 5))" style="width: 100%; display: flex;">
      <el-button type="primary" size="small" icon="el-icon-circle-plus-outline" @click="addBanner">{{ adId === 2 ? "添加视频" : "添加图片(最多5张)"}}</el-button>
    </div>

    <div class="banners_box" v-for="(blist, index) in banners">

      <div class="banner-images-box" style="width: 100%; margin-bottom: 10px; display: flex; align-items: center; ">
        <span>上传{{ adId === 2 ? "视频(100M以内)" : "图片(5M以内)" }}：</span>
        <el-input style=" flex: 1;" @input="change()" v-model="blist.picVideoContent" :placeholder="adId === 2 ? '上传视频' : '上传图片'"></el-input>
        <div style=" margin-left: 4px; display: flex;">
          <el-upload
            :drag="col.drag"
            :data="col.option"
            :headers="uploadHeaders"
            :accept="adId === 2 ? '.mp4,.webm' : '.png,.jpg,.jpeg,.gif'"
            class="avatar-uploader"
            :on-success="(response, file, fileList)=> banners_uploadSuc(response, file, fileList, col, index, 'picVideoContent')"
            :action="col.action || defaultUploadUrl"
            :show-file-list="false"
            :auto-upload="true"
            :before-upload="(file) => uploadProgress(file,col,adId === 2 ? '100' : '5', adId === 2 ? '.mp4,.webm' : '.png,.jpg,.jpeg,.gif', 'picVideoContent')"
          >
          <div v-if="adId === 2" style=" display: flex; align-items: center; ">
            <i class="el-icon-upload"></i>
          </div>
          <div v-else>
            <img title="上传新图片" style="width: 40px; height: 40px; display: flex;" v-if="blist.picVideoContent" :src="blist.picVideoContent">
            <i v-else class="el-icon-upload"></i>
          </div>
          <span style="font-size: 12px;">{{col.picLoading}}</span>
          </el-upload>
        </div>
      </div>
      
      <div v-if="adId === 2" style="display: flex; align-items: center; gap: 5px;">
        <video ref="videoElement" crossorigin="anonymous" v-if="blist.picVideoContent" width="320" height="180" controls preload="metadata" :key="blist.picVideoContent">
          <source :src="blist.picVideoContent" type="video/mp4">
        </video>
        <el-button :disabled="captureBtn" @click="captureVideo(col.action || defaultUploadUrl,col,index)" type="success" size="mini">截图上传</el-button>
        <canvas ref="canvas" style="display: none;"></canvas>
      </div>

      <div class="banner-images-box" style="width: 100%; margin-top: 10px; display: flex; align-items: center;" v-if="adId === 2">
        <span>视频截图(5M以内)：</span>
        <el-input style=" flex: 1;" @input="change()" v-model="blist.videoPreviewImage" placeholder="视频截图"></el-input>
        <div style=" margin-left: 4px; display: flex;">
          <el-upload
            :drag="col.drag"
            :data="col.option"
            :headers="uploadHeaders"
            accept=".png,.jpg,.jpeg,.gif"
            class="avatar-uploader"
            :on-success="(response, file, fileList)=> banners_uploadSuc(response, file, fileList, col, index, 'videoPreviewImage')"
            :action="col.action || defaultUploadUrl"
            :show-file-list="false"
            :auto-upload="true"
            :before-upload="(file) => uploadProgress(file,col,5,'.png,.jpg,.jpeg,.gif','videoPreviewImage')"
          >
          <div>
            <img title="上传新截图" style="width: 40px; height: 40px; display: flex;" v-if="blist.videoPreviewImage" :src="blist.videoPreviewImage">
            <i v-else class="el-icon-upload"></i>
          </div>
          <span style="font-size: 12px;">{{col.videoLoading}}</span>
          </el-upload>
        </div>
      </div>

      <div style="width: 100%;" v-if="adId === 2">
        <el-button type="danger" size="mini" icon="el-icon-delete" @click="removeBanner(index)">删除视频</el-button>
      </div>

      <div style="width: 100%; display: flex; align-items: center;" v-if="adId === 1">
        <span>图片排序：</span><el-input style="width: 60px;" @input="change()" v-model="blist.sort" placeholder="排序" :maxlength="4"></el-input>

        <span style="margin-left: 4px;">跳转方式：</span>
        <el-select style="width: 180px;" @input="change()" v-model="blist.redirectType" placeholder="跳转方式">
          <el-option :value="1" label="内部跳转"></el-option>
          <el-option :value="2" label="外部跳转-新窗口打开"></el-option>
          <el-option :value="3" label="外部跳转-系统内打开"></el-option>
        </el-select>

        <span style="margin-left: 4px;">显示隐藏：</span>
        <el-switch 
          @input="change()"
          v-model="blist.bannerDelete"
          active-color="var(--brand-primary)"
          inactive-color="#cccccc"
          :active-value="1"
          :inactive-value="2"
        ></el-switch>

        <el-button style="margin-left: auto;" type="danger" size="mini" circle icon="el-icon-delete" @click="removeBanner(index)"></el-button>
      </div>

      <div style="width: 100%; margin-top: 10px; display: flex; align-items: center;" v-if="adId === 1">
        <span>跳转{{blist.redirectType === 1 ? "页面" : "地址"}}：</span>
        <el-select style=" flex: 1;" v-if="blist.redirectType === 1" @input="change()" v-model="blist.redirectUrl">
          <el-option value="/home" label="首页"></el-option>
          <el-option value="/task" label="任务"></el-option>
          <el-option value="/exchange" label="兑换"></el-option>
          <el-option value="/mine" label="我的"></el-option>
          <el-option value="/home/msgcenter" label="消息中心"></el-option>
          <el-option value="/task/record" label="任务记录"></el-option>
          <el-option value="/exchange/record" label="兑换记录"></el-option>
        </el-select>
        <el-input v-else style=" flex: 1;" @input="change()" v-model="blist.redirectUrl" placeholder="跳转地址" show-word-limit></el-input>
      </div>
    </div>

  </div>
</template>

<script>
export default {
    props: ['value','adId','col','uploadHeaders'],
    data() {
        return {
          banners: this.value || [],
          captureBtn: false
        }
    },
    methods: {
      addBanner() {
        if (this.adId === 1) {
          this.banners.push({
            picVideoContent: '',
            redirectUrl: '',
            redirectType: 1,
            bannerDelete: 1,
            sort: 0
          })
        } else {
          this.banners.push({
            picVideoContent: ''
          })
        }        
      },
      removeBanner(index){
        this.banners.splice(index,1);
      },
      change(){
        this.$emit('input', this.banners)
        this.$forceUpdate();
      },
      banners_uploadSuc(response, file, fileList, col, index, key){
        if (response.code == 0) {
          this.banners[index][key] = response.result;
          col.picLoading = "";
          col.videoLoading = "";
        } else {
          if (key === 'picVideoContent') {
            col.picLoading = window.$t('page.uploadFail');
          } else {
            col.videoLoading = window.$t('page.uploadFail');
          }
        }
        this.change();
      },
      uploadProgress(file, col, maxfileSize = 1024, accept = '',key){
        const fileSize = file.size / 1024 / 1024;
        if (accept){
          const extension = accept.split(',').map(item => item.replace('.',''));
          const fileType = file.type.split('/')[1];
          if (!extension.includes(fileType)){
            this.$message.error(`只能上传${accept}格式图片`);
            return false;
          }
        }
        if (fileSize > maxfileSize){
          this.$message.error(`文件大小不能超过${maxfileSize}M`);
          return false;
        }
        if (key === 'picVideoContent') {
          col.picLoading = window.$t('page.uploading');
        } else {
          col.videoLoading = window.$t('page.uploading');
        }        
        this.$forceUpdate();
      },
      captureVideo(action,col,index) {
        this.captureBtn = true;
        const video = this.$refs.videoElement[0];
        const canvas = this.$refs.canvas[0];
        if (!video) {
          this.$message.error('视频未加载完成');
          return;
        }
        canvas.width = video.clientWidth;
        canvas.height = video.clientHeight;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        canvas.toBlob(async (blob) => {
          const formData = new FormData();
          formData.append('file', blob, 'screenshot.png');
          const response = await axios.post(
            action,
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data',
                ...this.uploadHeaders
              }
            }
          );
          this.banners_uploadSuc(response, "", [], col, index,'videoPreviewImage');
          this.$message.success('截图上传成功');
          this.captureBtn = false;
        }, 'image/png');
      }
    },
    watch: {
      value: {
        handler(newVal) {
          this.banners = newVal
        },
        deep: true
      }
    }
}
</script>

<style scoped>
.banners_box {
  border: dashed 1px #dedede; 
  margin: 15px 0 15px 0; 
  padding: 10px; 
  border-radius: 5px; 
  box-sizing: border-box;
}
</style>